export default __webpack_public_path__ + "static/media/bg-main-back.fe2bf287.jpg";